<template>
  <label class="checkbox">
    <input
      class="checkbox__input"
      type="checkbox"
      :name="name"
      :checked="modelValue"
      :disabled="disabled"
      @change="onChange"
    >
    <span class="checkbox__title">{{ title }}</span>
  </label>
</template>
<script>

/**
 * @description Название события ввода.
 * @type {string}
 */
const NAME_EVENT_UPDATE_MODEL_VALUE = 'update:modelValue';

/**
 * @description Компонент флажка.
 * @type {Vue}
 */
export default {
  name: 'InputCheckbox',
  props: {
    /**
     * @description Деактивирован.
     */
    disabled: { default: () => false, type: Boolean },
    /**
     * @description Заголовок.
     */
    title: { default: () => '', type: String },
    /**
     * @description Значение.
     */
    modelValue: { required: true, type: Boolean },
    /**
     * @description Название поля.
     */
    name: { default: () => '', type: String },
  },
  emits: [NAME_EVENT_UPDATE_MODEL_VALUE],
  methods: {
    /**
     * @description Обработать изменение.
     * @param {Event} event
     * @returns {void}
     */
    onChange(event) {
      this.$emit(NAME_EVENT_UPDATE_MODEL_VALUE, event.target.checked);
    },
  },
};
</script>
<style scoped>
.checkbox {
  width: fit-content;
  overflow-wrap: anywhere;
}
.checkbox > .checkbox__input {
  opacity: 0;
  position: absolute;
  z-index: -1;
}
.checkbox > .checkbox__title {
  align-items: center;
  display: inline-flex;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  user-select: none;
  cursor: pointer;
}
.checkbox > .checkbox__title::before {
  background-color: var(--primary-background-color);
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 70%;
  border: 1px solid var(--unfocus-color);
  border-radius: 4px;
  content: '';
  display: inline-block;
  flex-grow: 0;
  flex-shrink: 0;
  height: 1.5rem;
  margin: 0 10px 0 0;
  width: 1.5rem;
}
.checkbox > .checkbox__input:not(:disabled, :checked) + .checkbox__title:hover::before {
  border-color: var(--action-color);
}
.checkbox > .checkbox__input:not(:disabled):active + .checkbox__title::before {
  background-color: var(--unfocus-color);
  border-color: var(--unfocus-color);
}
.checkbox > .checkbox__input:focus:not(:checked) + .checkbox__title::before {
  border-color: var(--unfocus-color);
}
.checkbox > .checkbox__input:checked + .checkbox__title::before {
  background-color: var(--action-color);
  border-color: var(--action-color);
}
.checkbox > .checkbox__input:checked + .checkbox__title::before {
  background-image: url("@/assets/img/checked-white-top.svg");
}
</style>
